<template>
  <popup
    title="СТЕНД"

    :value="value"
    :styles="{'width': '1062px'}"
    @input="$emit('input', $event)"
  >
    <template v-slot:content>
      <div
        class="stand-information"
        :style="{'height': showVideo ? 'auto' : ''}">
        <vuescroll
          :ops="ops"
          ref="vs"
          class="stand-information__catalog"
          v-if="!showVideo"
        >
          <img
            :src="page"
            class="stand-information__image"
            v-for="(page, index) in getFaculty.catalog"
            :key="index"
          >
        </vuescroll>
        <div class="embed-responsive embed-responsive--16by9" v-else>
          <iframe
            :src="getFaculty.video"
            class="embed-responsive__iframe"
            allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          />
        </div>
      </div>
    </template>
    <template v-slot:footer>
      <div class="stand-information-footer">
        <a
          :href="getFaculty.presentation"
          class="btn stand-information-footer__button stand-information-footer__button--download click-sound"
          :download="getFaculty.name"
          @click="downloadPresentation"
          v-if="getFaculty.presentation"
        >
          <i class="stand-information-footer__icon"></i>
        </a>
        <button
          type="button"
          class="btn stand-information-footer__button stand-information-footer__button--download click-sound"
          :disabled="!getFaculty.presentation"
          @click="downloadPresentation"
          v-else
        >
          <i class="stand-information-footer__icon"></i>
        </button>
        <button
        type="button"
          class="btn stand-information-footer__button stand-information-footer__button--video click-sound"
          :disabled="!getFaculty.video"
          @click="openVideo"
        >
          <i
            class="stand-information-footer__icon stand-information-footer__icon--show"
            v-if="!showVideo"
          />
          <i
            class="stand-information-footer__icon stand-information-footer__icon--back"
            v-else
          />
        </button>
        <button
          type="button"
          class="btn stand-information-footer__button stand-information-footer__button--link click-sound"
          :disabled="!getFaculty.url"
          @click="openLink"
        >
          Перейти на сайт
        </button>
      </div>
    </template>
  </popup>
</template>

<script>
  import vuescroll from 'vuescroll'
  import Popup from '@/components/Popup'
  import { Faculties } from '@/data'

  export default {
    props: {
      value: {
        type: Boolean,
        default: false
      },
      stand: {
        type: Number,
        default: 1
      },
      currentPoint: {
        type: Number,
        default: 3
      }
    },
    data(){
      return {
        Faculties,
        showVideo: false,
        ops: {
          vuescroll: {
            detectResize: false
          },
          scrollPanel: {
            scrollingX: false
          },
          rail: {
            size: '13px',
            opacity: '.5',
            specifyBorderRadius: '0px',
            gutterOfEnds: '0px',
            gutterOfSide: '0px',
            background: '#000716'
          },
          bar: {
            size: '13px',
            opacity: '1',
            background: '#000716',
            keepShow: true
          }
        }
      }
    },
    components: {
      vuescroll,
      Popup
    },
    watch: {
      value(value){
        if(!value){
          this.showVideo = false;
          setTimeout(() => this.$refs.vs.scrollTo({y: 0}), 500);
        }
        else {
          if(this.currentPoint === 2) this.$emit('continueQuest', true, 3);
        }
      }
    },
    computed: {
      getFaculty(){
        return this.Faculties.find(faculty => faculty.id === this.stand);
      }
    },
    methods: {
      downloadPresentation(){
        if(!this.getFaculty.presentation) return;
      },
      openVideo(){
        if(!this.getFaculty.video) return;

        this.showVideo = !this.showVideo;
        this.$root.$emit('pause-music', this.showVideo);
      },
      openLink(){
        if(!this.getFaculty.url) return;

        window.open(this.getFaculty.url, '_blank');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .stand-information {
    display: flex;
    height: 750px;
    align-items: center;

    &__image {
      display: block;
      width: 100%;
      height: auto;
      margin: 0 auto;
      user-select: none;
      pointer-events: none;
    }
  }
  .embed-responsive {
    position: relative;
    display: block;
    width: 100%;
    padding: 0;
    overflow: hidden;

    &::before {
      display: block;
      content: '';
    }
    &--16by9::before {
      padding-top: 56.25%;
    }
    &__iframe {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none;
    }
  }
  .stand-information-footer {
    display: flex;

    &__button {
      min-width: auto;
      margin: 0 20px 0 0;

      &:last-child {
        margin-right: 0;
      }
      &--download {
        display: flex;
        width: 89px;
        height: 89px;
        padding: 0;
        align-items: center;
        justify-content: center;
      }
      &--video {
        display: flex;
        width: 89px;
        height: 89px;
        padding: 0;
        align-items: center;
        justify-content: center;
      }
      &--link {
        width: 772px;
        margin-left: auto;
      }
    }
    &__icon {
      display: block;
      background-repeat: no-repeat;
      background-size: cover;
      pointer-events: none;
    }
    &__button--download &__icon {
      width: 34px;
      height: 34px;
      background-image: url(/images/icons/download.png);
    }
    &__button--video &__icon--show {
      width: 50px;
      height: 32px;
      background-image: url(/images/icons/video.png);
    }
    &__button--video &__icon--back {
      width: 35px;
      height: 47px;
      background-image: url(/images/icons/back.png);
    }
  }
</style>
